
import { useState } from "react";
import { supabase } from "@/lib/supabase";
import { ExtendedOrganization } from "./types";

export const useOrganizationUpdate = (
  organization: ExtendedOrganization | null,
  setOrganization: (org: ExtendedOrganization | null) => void
) => {
  const [isSaving, setIsSaving] = useState(false);

  const updateOrganization = async (name: string) => {
    if (!organization) {
      return { success: false, error: "Utilisateur ou organisation non trouvé" };
    }
    
    try {
      setIsSaving(true);
      
      const { error } = await supabase
        .from('organizations')
        .update({ name, updated_at: new Date().toISOString() })
        .eq('id', organization.id);
        
      if (error) throw error;
      
      // Fixed type error by creating a new object with the updated name
      setOrganization({ ...organization, name });
      
      return { success: true };
    } catch (error: any) {
      console.error("Erreur lors de la mise à jour de l'organisation:", error.message);
      return { success: false, error: error.message };
    } finally {
      setIsSaving(false);
    }
  };

  return { isSaving, updateOrganization };
};
